import axios from "axios";

export const fetchPermission = async () => {
  return await axios({
    baseURL: process.env.REACT_APP_BASE_URL,
    method: "GET",
    url: `user/permissions/`,
  });
};
